import __base_store from '@/store/__base_store'

/**
 * Store de estados de lote de producción (modelo `production_batch_status`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'production_batch_status',
	},
})

